import { composeIO } from 'react-compose-io'
import { popoverFiltroPossiveisTratativasIO } from './PopoverFiltroPossiveisTratativas.IO'
import { PopoverFiltroPossiveisTratativasView } from './PopoverFiltroPossiveisTratativas.View'

export const PopoverFiltroPossiveisTratativas = composeIO(PopoverFiltroPossiveisTratativasView, popoverFiltroPossiveisTratativasIO)
